import { useEffect, useState, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
/*import MeetingCalendar from "../components/calendar/MeetingCalendar";
import Meeting from "../components/meeting/Meeting";
import SitePage from "../components/sitepage/SitePage";*/
import { useNavigate } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import AuthLogin from "../components/auth/AuthLogin";
export default function LoginRoute() {

    const [selectedMeeting, setSelectedMeeting] = useState(null);
    const navigate = useNavigate();


    return (
        <>
            <Container>
                <AuthLogin />
            </Container>
        </>
    );
}